export class RestoreGcpVmInstanceRequest {
    'restoreAccountId';
    'destination';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "destination",
            "baseName": "destination",
            "type": "GcpVmInstanceRestoreDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreGcpVmInstanceRequest.attributeTypeMap;
    }
    constructor() {
    }
}
